import axios from 'axios';
import { env } from '../config/env';
import i18n from '../i18n/i18n';

const api = axios.create({
  baseURL: `${env.API_URL}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': i18n.language || 'en'
  },
});

// Add request interceptor for authentication if needed
api.interceptors.request.use(
  (config) => {
    // Update language header with current language
    if (config.headers) {
      config.headers['Accept-Language'] = i18n.language || 'en';
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle specific error cases
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.error('API Error:', error.response.data);
    } else if (error.request) {
      // The request was made but no response was received
      console.error('Network Error:', error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default api; 